import { ContentCard, rem } from '@innovyze/stylovyze';
import styled from 'styled-components';

export const ZeroTouchWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(735px, 1fr));
	grid-gap: ${rem(32)};

	@media (max-width: 900px) {
		display: flex;
		flex-direction: column;
	}
`;

export const ContentBodyWrapper = styled.div`
	padding: 22px;
`;

export const StyledContentCard = styled(ContentCard)`
	height: min-content;

	@media (min-width: 2400px) {
		&.comp-table {
			grid-column: span 2;
		}
	}

	> * {
		box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
			0px 1px 1px 0px rgba(0, 0, 0, 0.14),
			0px 1px 3px 0px rgba(0, 0, 0, 0.12);
	}
`;
